import React, { useCallback, useState } from 'react';
import { useSend } from '@sc1/common/hooks';
import { bulkInputToArray, VaultUpgradable } from '@sc1/common';
import { Box, Row, Heading, Card, Input, Textarea } from '../core';
import { StatusButton } from '../StatusButton';
import type { CardProps } from 'theme-ui';

interface SeizeStrategyProps extends CardProps {
  vault: VaultUpgradable | undefined;
  disabled: boolean;
}
export const SeizeStrategy = ({
  vault,
  disabled,
  ...rest
}: SeizeStrategyProps): JSX.Element => {
  const [address, setAddress] = useState<string>('');
  const [bulkTokens, setBulkTokens] = useState<string[]>([]);

  const { sendTx, txStatus } = useSend();

  const addStrategy = useCallback(
    () => vault && sendTx(vault, 'seizeStrategy', [address, bulkTokens]),
    [vault, address, bulkTokens, sendTx]
  );

  return (
    <Card {...rest}>
      <Heading as="h3" mb={3}>
        Seize Strategy
      </Heading>
      <Box>
        Strategy
        <Input
          mt={1}
          mb={3}
          disabled={disabled}
          value={address}
          placeholder="0x..."
          onChange={(e) => setAddress(e.target.value)}
        />
        Tokens
        <Textarea
          mt={1}
          placeholder="0x... Separate addresses by comma, space, or linebreak"
          onChange={(e) => setBulkTokens(bulkInputToArray(e.target.value))}
        />
        <Row variant="collapse">
          <StatusButton
            mt={2}
            disabled={disabled}
            onClick={addStrategy}
            status={txStatus}
          >
            Seize Strategy
          </StatusButton>
        </Row>
      </Box>
    </Card>
  );
};
